import {
  getModule,
  Module,
  VuexModule,
  Mutation,
} from 'vuex-module-decorators';
import { store } from './store';

@Module({
  dynamic: true,
  name: 'user',
  namespaced: true,
  stateFactory: true,
  store,
})
export class UserModule extends VuexModule {
  public organization: any = {};
  public firstName: string = '';
  public lastName: string = '';
  public email: string = '';

  @Mutation
  public SET_ORGANIZATION(organization: any) {
    this.organization = organization;
  }

  @Mutation
  public SET_USER_DATA({
    firstName,
    lastName,
    email,
  }: {
    firstName: string;
    lastName: string;
    email: string;
  }) {
    this.firstName = firstName;
    this.lastName = lastName;
    this.email = email;
  }
}

export const userState = getModule(UserModule);
